import storage from "@/utils/storage";
import session from "@/utils/session";

import { userInfo } from "@/api/cust";
import { paytype } from "@/api/pay";

const user = {
  state: {
    token: storage.get("app-token"),
    userInfo: false,
    channel: storage.get("channel"),
    payType: storage.getJson("pay-type"),
    showLuanch: false,
    mallCategory: true,
  },
  getters: {
    token: state => {
      return state.token;
    },
    isLogin: state => {
      return state.token != null && state.token.length > 10;
    },
    userInfo: state => {
      return state.userInfo;
    },
    channel: state => {
      return state.channel;
    },
    payType: state => {
      return state.payType;
    },
    showLuanch: state => {
      return state.showLuanch;
    },
    mallCategory: state => {
      return state.mallCategory;
    }
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      console.log("set token : " + token)
      if (token) {
        storage.set("app-token", token);
      } else {
        storage.del("app-token");
      }
    },
    setChannel(state, channel) {
      state.channel = channel;
      if (channel) {
        storage.set("channel", channel);
      } else {
        storage.del("channel");
      }
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      if (userInfo) {
        storage.setJson("user-info", userInfo);
      } else {
        storage.del("user-info");
      }
    },
    setPayType(state, value) {
      state.payType = value;
      if (value) {
        storage.setJson("pay-type", value);
      } else {
        storage.del("pay-type");
      }
    },
    setShowLuanch(state, value) {
      state.showLuanch = value;
      if (value) {
        storage.setJson("show-luanch", value);
      } else {
        storage.del("show-luanch", value);
      }
    },
    setMallCategory(state, value) {
      state.mallCategory = value;
    },
    logout(state) {
      state.token = '';
      state.channel = ''
      localStorage.setItem("isHiddenLottery", false)
      localStorage.setItem("isHiddenMid", false)
      storage.del("loginSuccess")
      storage.del("pay-type")
      storage.del("user-info")
      storage.del("adShow")
      storage.del("channel")
      storage.del("app-token")
      storage.del("cache-info")
      session.del("payForm")
      storage.del("show-luanch")
      storage.del("wechat_auth_status")
      session.del("listBanner")
      session.del("notifies")
      storage.del("showAddress")
    },
    setUserInfoIsProm(state, isProm) {
      state.userInfo.isProm = isProm;
    }
  },
  actions: {
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        userInfo()
          .then(data => {
            console.log("setUserInfo : %O", data)
            commit("setUserInfo", data);
            console.log("setChannel : %O", data.custChannel)
            commit("setChannel", data.custChannel);
            resolve(data);
          })
          .catch(e => {
            reject(e);
          });
      });
    },

    //静默登录
    silenceAuth({ state, commit }) {
      return new Promise((resolve, reject) => {
        userInfo()
          .then(data => {
            console.log("setUserInfo : %O", data)
            commit("setUserInfo", data);
            console.log("setChannel : %O", data.custChannel)
            commit("setChannel", data.custChannel);
            // commit("setShowLuanch", true);
            resolve(data);
          })
          .catch(e => {
            reject(e);
          });
        paytype({ chanlCode: state.channel }).then((data) => {
          commit("setPayType", data);
        }).catch(e => {
          reject(e);
        });
      });
    },
  }
};

export default user;
